@if (((homeDetailsPending$ | async) === false && !!(homeDetails$ | async)) || isRealtor) {
	<mat-sidenav-container>
		@let realtorInfo = realtorInfo$ | async;
		@let homeDetails = homeDetails$ | async;
		<mat-sidenav #sidenav mode="over" role="dialog" aria-modal="true" aria-label="side-nav-menu">
			<div *cpIfViewSize="['tablet', 'mobile']" class="cp-flex-container">
				<div class="cp-flex-col">
					<div class="cp-flex-row cp-icon">
						<button mat-icon-button class="cp-focus-indicator" (click)="onCloseClick()" disableRipple aria-label="close-sidenav" [attr.data-ai-dnt]="'dnt'">
							<mat-icon fontSet="material-symbols-outlined">close</mat-icon>
						</button>
					</div>
					<div class="cp-flex-row cp-customer-name">
						<h1 data-testid="customer-name">
							@if (isPreviewRealtor() && realtorInfo) {
								Welcome, {{ realtorInfo.firstName }}
							} @else {
								Welcome, {{ (userInfo$ | async)?.firstName }}
							}
						</h1>
					</div>
					@if (!isOnRealtorHomesPage) {
						@if (primaryOwnerName$ | async; as name) {
							<span class="cp-flex-row cp-primary-owner">
								<mat-icon
									fontSet="material-symbols-outlined"
									class="cp-primary-owner-icon"
									[svgIcon]="'nav_house_chimney'">
								</mat-icon>
								{{ name }}
							</span>
						}
					}
					@if (!isOnRealtorHomesPage && homeDetails) {
						<div class="cp-flex-row cp-address">
							<span>{{homeDetails.lot.streetAddress1.trim()}},{{homeDetails.lot.streetAddress2.trim() ? ' ' + homeDetails.lot.streetAddress2.trim() + ',' : ''}}</span>
							<span>{{homeDetails.lot.city.trim()}}, {{homeDetails.lot.stateProvince.trim()}} {{homeDetails.lot.postalCode.trim()}}</span>
						</div>
					}
					@if (!isRealtor && !isPreviewRealtor()) {
						<div class="cp-flex-row cp-my-account">
							<a mat-button class="cp-focus-indicator" [href]="myAccountUrl" target="_blank" rel="noopener noreferrer" disableRipple (click)="onMyAccountClick()">
								My Account
								<mat-icon fontSet="material-symbols-outlined" [attr.aria-hidden]="null" iconPositionEnd aria-label="opens-in-new-tab">
									open_in_new
								</mat-icon>
							</a>
						</div>
					}
					@if (isRealtorEnabled) {
						<!-- 
							Customers with realtor info can access the Realtor Access page
							Preview users without realtor mode enabled can also see the Realtor Access link if they have realtor info
							!isRealtor - It's either preview or customer
							!isPreviewRealtor() - Only show if isPreviewRealtor is false - isPreviewRealtor is always false for customers, and true for preview users accesing a preview/realtor route 
						-->
						@if (!isRealtor && realtorInfo && !isPreviewRealtor() && !isThirtyOneDaysPostClose) {
							<div class="cp-flex-row cp-realtor-access">
								<a mat-button class="cp-focus-indicator" role="button" tabindex="0" disableRipple (click)="onRealtorAccessClick()" (keypress)="keyPressHandler($event, onRealtorAccessClick())">
									Realtor Access
									<span class="cp-sr-only-aria">Opens Realtor Access page</span>
								</a>
							</div>
						}
					}
					<!-- 
						Realtor can perform password reset and profile management
						Preview users acessing a realtor route (isPreviewRealtor() is true) with realtor info can see password reset and profile management options (read-only/disabled)
					-->
					@if (isRealtor || (isPreview && isPreviewRealtor() && realtorInfo)) {
						<div class="cp-flex-row cp-password-reset">
							<button mat-button
								disableRipple
								[disabled]="isPreview"
								aria-label="Password Reset"
								(click)="onResetPassword()">
								Password Reset
							</button>
						</div>
						<div class="cp-flex-row cp-profile-management">
							<button mat-button
								disableRipple
								[disabled]="isPreview"
								aria-label="Profile Management"
								(click)="onProfileManagement()">
								Profile Management
							</button>
						</div>
					}
					@if (homeDetails && showNavigation) {
						<div class="cp-flex-row cp-give-feedback">
							<button mat-button
								disableRipple
								aria-label="Give Feedback"
								data-testid="give-feedback-button"
								(click)="onGiveFeedbackClick()">
								Give Feedback
							</button>
						</div>
					}
					<button class="cp-logout"
						mat-button
						disableRipple
						[disabled]="isPreview"
						aria-label="Logout"
						(click)="onLogout()"
						(keypress)="keyPressHandler($event, onLogout())">
						Logout
					</button>
				</div>
			</div>
		</mat-sidenav>
		<mat-sidenav-content>
			<header>
				<cp-header class="cp-main-header" [isPreviewRealtor]="isPreviewRealtor()" (hamburgerClicked)="sidenav.toggle()"></cp-header>
			</header>
			<!-- The scroll action is added here for desktop due to the scrolling action being handled inside the cp-nav-container container -->
			<div class="cp-nav-container" (scroll)="scrollService.handleScroll($event)" #cpNavContainer>
				@if (showNavigation) {
					<div class="cp-sidenav-content">
						<cp-navigation [isPreviewRealtor]="isPreviewRealtor()"></cp-navigation>
					</div>
				}
				<!-- The scroll action is added here for mobile due to the scrolling action being handled inside the cp-main-content container -->
				<div class="cp-main-content" (scroll)="scrollService.handleScroll($event)" #cpMainContent>
					<main>
						<router-outlet></router-outlet>
					</main>
					<footer>
						<cp-footer></cp-footer>
					</footer>
				</div>
			</div>
		</mat-sidenav-content>
	</mat-sidenav-container>
}

@if (!!(spinnerActive$ | async)) {
	<cp-spinner></cp-spinner>
}